import React, { useState, useEffect } from "react";
import { useAppContext } from "../context/appContext";
import LoadingSpinner from "./../components/UI/LoadingSpinner";
import Form from "../components/landing/Form";
import { Navigate } from "react-router-dom";

const initialState = "";

const Landing = () => {
    // const navigate = useNavigate();

    const [inputVal, setInputVal] = useState("");

    const { loginUser, isLoading, user } = useAppContext();

    const addNum = (e) => {
        e.stopPropagation();
        let newValue = inputVal.toString() + e.target.dataset.val;
        setInputVal(newValue);
    };

    const clearLastDigit = (e) => {
        let sliced = inputVal;
        sliced = sliced.slice(0, -1);
        setInputVal(sliced);
    };

    const clearField = (e) => {
        setInputVal("");
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!inputVal) {
            //Show error needed
            return;
        }
        loginUser(inputVal);
        setInputVal("");
    };

    return (
        <>
            {user && <Navigate to='/dashboard' />}
            <div className='mx-auto flex max-w-5xl flex-1 content-center items-center '>
                <div className='glass mx-auto flex max-w-sm flex-1 flex-col content-center items-center p-8'>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Form
                            inputVal={inputVal}
                            onClearLastDigit={clearLastDigit}
                            onClearField={clearField}
                            onSubmit={onSubmit}
                            addNum={addNum}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default Landing;
